import React from 'react';
import { ImSpinner8 } from 'react-icons/im'; // Import spinner icon

function CircularProgress() {
  return (
    <div className="flex justify-center items-center mt-4">
    {/* Cool spinner from react-icons */}
    <ImSpinner8 className="animate-spin text-4xl text-primaryColor" />
  </div>
  );
}

export default CircularProgress;